import { render, staticRenderFns } from "./OriginMarketApplyList.vue?vue&type=template&id=1e9503be&scoped=true&"
import script from "./OriginMarketApplyList.vue?vue&type=script&lang=js&"
export * from "./OriginMarketApplyList.vue?vue&type=script&lang=js&"
import style0 from "./OriginMarketApplyList.vue?vue&type=style&index=0&id=1e9503be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9503be",
  null
  
)

export default component.exports